import { useLocation } from "react-router-dom";
import { Menu, Bell, Calendar } from "lucide-react";
import { routes } from "../routes/routeConfig";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

//const Topbar = ({ setOpen }) => {
  // const Topbar = ({ setOpen, selectedDate, setSelectedDate }) => {
    const Topbar = ({
  setOpen,
  selectedDate,
  setSelectedDate
}) => {
  
  const location = useLocation();
  const [showCalendar, setShowCalendar] = useState(false);
 // const [selectedDate, setSelectedDate] = useState(new Date());
  const navigate = useNavigate();

  const currentRoute = routes
    .filter((r) => r.title && r.path !== "/")
    .sort((a, b) => b.path.length - a.path.length)
    .find((r) => location.pathname.startsWith(r.path));

  const title = currentRoute?.title || "Dashboard";

  const isLiveClassPage = location.pathname === "/live-classes";

  return (

    <>
      <div className="bg-primary sticky text-white px-4 md:px-6 py-3 flex items-center justify-between shadow">

        {/* Left */}
        <div className="flex items-center gap-3">

          {/* Mobile Menu Button */}
          <button
            className="md:hidden"
            onClick={() => setOpen(true)}
          >
            <Menu className="w-6 h-6" />
          </button>
          <h1 className="text-base md:text-lg font-semibold uppercase truncate max-w-[150px] md:max-w-none">
            {title}
          </h1>

        </div>
        {/* 
      Right
      <div className="flex items-center gap-3 md:gap-4 text-sm">

        <span className="hidden sm:block">Today’s Session</span>

        <div className="bg-white text-black px-3 py-1 rounded-full text-xs md:text-sm">
          {new Date().toLocaleDateString()}
        </div>

        <div className="w-8 h-8 bg-white rounded-full" />

      </div> */}
        <div className="flex items-center gap-3 md:gap-4 text-sm">


          {/* Hide on very small screens */}
          {isLiveClassPage && (
            <>
              <span className="hidden sm:block">Today’s Session</span>

              {/* DATE DISPLAY */}
              <div className="bg-primary text-white">
                {selectedDate.toLocaleDateString()}
              </div>

              {/* CALENDAR ICON */}
              <button
                onClick={() => setShowCalendar(!showCalendar)}
                className="p-2 rounded-full hover:bg-white/20 transition relative"
              >
                <Calendar className="w-4 h-4 md:w-5 md:h-5" />
              </button>
            </>
          )}
          {/* Notification Icon (only on tablet+) */}
          <Bell className="w-5 h-5 hidden sm:block" />

          {/* Profile */}
          <div className="w-8 h-8 bg-white rounded-full" />
        </div>
      </div>

      {/* CALENDAR POPUP */}
      {showCalendar && (
  <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
    
    <div className="bg-white rounded-lg p-4 shadow-lg">
      
      <DatePicker
        selected={selectedDate}
        onChange={(date) => {
          setSelectedDate(date);
          setShowCalendar(false);
        }}
        inline
      />

    </div>
  </div>
)}
    </>


  );
};

export default Topbar;